<script>
import { mapState } from 'pinia';
import { useFeedStore } from '../../store/useFeedStore.js';
import { useHeaderStore } from '../../store/useHeaderStore.js';

export default {
  name: 'CpSidebarMenuGlobal',
  components: {
    CpBaseSvgIcon: require('./base-svg-icon').default,
    SidebarMenuHomeIcon: require('./social-feed/icons/home').default,
    SidebarMenuTvIcon: require('./social-feed/icons/tv').default,
    SidebarMenuPetitionIcon: require('./social-feed/icons/petition').default,
    SidebarMenuDebatesIcon: require('./social-feed/icons/debates').default,
    SidebarMenuRacesIcon: require('./social-feed/icons/races').default,
    CpInviteMembersDialog: require('./dialogs/invite-members').default,
    CpMyRepresentatives: require('./lobbying/MyRepresentatives.vue').default,
  },
  props: {
    withMyRepresentatives: { type: Boolean, default: true },
  },
  data: function () {
    return {
      isOpenMoreOptions: false,
    };
  },
  methods: {
    handleLinkClick(categoryClicked) {
      const path = categoryClicked === 'home' ? '/feed' : `/${categoryClicked}`;
      window.location.href = path;
    },
    handleMoreOptions() {
      this.isOpenMoreOptions = !this.isOpenMoreOptions;
    },
    isActiveCategory(category) {
      const currentPath = window.location.pathname;

      const categoryRoutes = {
        home: '/feed',
        campaigns: '/campaigns',
        community: '/community',
        news: '/news',
        groups: '/groups',
        polls: '/polls',
        representatives: '/representatives',
        members: '/members',
        active_races: '/active_races',
        events: '/events',
        petitions: '/petitions',
        blogs: '/blogs',
        tv: '/tv',
      };

      const expectedPath = categoryRoutes[category];
      if (!expectedPath) return false;

      if (category === 'home') {
        return currentPath === '/feed';
      }

      return currentPath === expectedPath;
    },
  },
  computed: {
    ...mapState(useFeedStore, ['sidebarCategory']),
    ...mapState(useHeaderStore, ['sitewideBannerInfo']),
    calculatedStickySidebarTop() {
      return this.sitewideBannerInfo.visible ? 80 + this.sitewideBannerInfo.height : 80;
    },
  },
};
</script>
<template>
  <div class="sticky-sidebar-menu-container" :style="{ top: `${calculatedStickySidebarTop}px`, '--sidebar-top': `${calculatedStickySidebarTop}px` }">
    <nav v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet }">
      <a class="sidebar-link" v-on:click="handleLinkClick('home')" v-bind:class="{ active: isActiveCategory('home'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-compass icon"></i>
          <span class="subhead sidebar-menu-title">Latest</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('campaigns')" v-bind:class="{ active: isActiveCategory('campaigns'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-podium icon"></i>
          <span class="subhead sidebar-menu-title">Campaigns</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('community')" v-bind:class="{ active: isActiveCategory('community'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-people-arrows icon"></i>
          <span class="subhead sidebar-menu-title">Community</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('news')" v-bind:class="{ active: isActiveCategory('news'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-rss-square icon"></i>
          <span class="subhead sidebar-menu-title">News</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('groups')" v-bind:class="{ active: isActiveCategory('groups'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-user-friends icon"></i>
          <span class="subhead sidebar-menu-title">Groups</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('petitions')" v-bind:class="{ active: isActiveCategory('petitions'), mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-file-signature icon"></i>
          <span class="subhead sidebar-menu-title">Petitions</span>
        </div>
      </a>
      <a
        class="sidebar-link"
        v-on:click="handleLinkClick('representatives')"
        v-bind:class="{ active: isActiveCategory('representatives'), mobile: $root.isMobile }"
      >
        <div class="social-sidebar-menu-item">
          <i class="fal fa-landmark icon"></i>
          <span class="subhead sidebar-menu-title">{{ $root.isSmallDesktop ? 'Represent...' : 'Representatives' }}</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleMoreOptions()" v-bind:class="{ mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal icon" :class="{ 'fa-plus-circle': !isOpenMoreOptions, 'fa-minus-circle': isOpenMoreOptions }"></i>
          <span class="subhead sidebar-menu-title">More...</span>
        </div>
      </a>
      <div v-show="isOpenMoreOptions" class="more-options-container">
        <a class="sidebar-link" v-on:click="handleLinkClick('members')" v-bind:class="{ active: isActiveCategory('members'), mobile: $root.isMobile }">
          <div class="social-sidebar-menu-item">
            <i class="fal fa-users icon"></i>
            <span class="subhead sidebar-menu-title">Members</span>
          </div>
        </a>
        <a
          class="sidebar-link"
          v-on:click="handleLinkClick('active_races')"
          v-bind:class="{ active: isActiveCategory('active_races'), mobile: $root.isMobile }"
        >
          <div class="social-sidebar-menu-item">
            <i class="fal fa-flag-usa icon"></i>
            <span class="subhead sidebar-menu-title">Races</span>
          </div>
        </a>
        <a class="sidebar-link" v-on:click="handleLinkClick('events')" v-bind:class="{ active: isActiveCategory('events'), mobile: $root.isMobile }">
          <div class="social-sidebar-menu-item">
            <i class="fal fa-calendar-day icon"></i>
            <span class="subhead sidebar-menu-title">Events</span>
          </div>
        </a>
        <a class="sidebar-link" v-on:click="handleLinkClick('polls')" v-bind:class="{ active: isActiveCategory('polls'), mobile: $root.isMobile }">
          <div class="social-sidebar-menu-item">
            <i class="fal fa-poll icon"></i>
            <span class="subhead sidebar-menu-title">Polls</span>
          </div>
        </a>
        <a class="sidebar-link" v-on:click="handleLinkClick('blogs')" v-bind:class="{ active: isActiveCategory('blogs'), mobile: $root.isMobile }">
          <div class="social-sidebar-menu-item">
            <i class="fal fa-edit icon"></i>
            <span class="subhead sidebar-menu-title">Blogs</span>
          </div>
        </a>
        <!-- ToDo: Remove code commented after update the section  -->
        <!-- <a class="sidebar-link" v-on:click="handleLinkClick('tv')" v-bind:class="{ active: isActiveCategory('tv'), mobile: $root.isMobile }">
            <div class="social-sidebar-menu-item">
              <i class="fal fa-video icon"></i>
              <span class="subhead sidebar-menu-title">Crowdpac TV</span>
            </div>
            </a> -->
      </div>
    </nav>
  </div>
</template>

<style scoped>
.sticky-sidebar-menu-container {
  position: sticky;
  background-color: var(--white);
  padding: 18px;
  border-radius: var(--external-border-radius);
  border: 1px solid var(--neutral-1);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - var(--sidebar-top, 80px));
  scroll-behavior: smooth;
}
.sticky-sidebar-menu-container::-webkit-scrollbar {
  width: 5px;
}
.sticky-sidebar-menu-container::-webkit-scrollbar-thumb {
  background-color: var(--primary);
  border-radius: 3px;
}

div.social-sidebar-menu-item {
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.1em;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  padding: 9px;
}

a.sidebar-link {
  display: block;
  color: var(--black);
  font-weight: 600;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  cursor: pointer;
  border-radius: var(--internal-border-radius);
  margin: 10px 0;
  text-decoration: none;
}
a.sidebar-link.mobile .sidebar-menu-title {
  display: none;
}
a.sidebar-link:hover {
  color: var(--primary);
  background-color: var(--primary-1);
}
a.sidebar-link.active {
  color: var(--primary);
  background-color: var(--primary-1);
}
a.sidebar-link.active.mobile {
  background-color: var(--white);
  display: contents;
}
nav.tablet .social-sidebar-menu-item {
  padding: 5px 5px 5px 10px;
  margin-bottom: 7px;
}
nav.tablet span.sidebar-menu-title {
  font-size: 0.8em;
  padding-left: 8px;
}

nav.tablet .social-sidebar-menu-item svg {
  max-width: 25px;
}

span.sidebar-menu-title {
  padding-left: 7px;
  cursor: inherit;
  flex: 5;
}
nav.mobile div.social-sidebar-menu-item {
  padding: 0px;
  margin-bottom: 5px;
  justify-content: center;
}
.icon {
  font-size: 22px;
  flex: 1;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform-origin: center;
  text-align: center;
}
.social-sidebar-menu-item .icon.fa-minus-circle {
  transform: rotate(180deg);
}
.more-options-container {
  padding-left: 18px;
}
@media screen and (max-width: 768px) {
  .sticky-sidebar-menu-container {
    padding: 0px;
    border: none;
  }
  a.sidebar-link {
    width: fit-content;
  }
  .more-options-container .icon {
    font-size: 18px;
  }
}
@media screen and (max-width: 450px) {
  .more-options-container .icon {
    font-size: 16px;
  }
}
</style>
